import {
    Card,
    CardContent,
    CardHeader,
    FormControl,
    FormControlLabel,
    FormHelperText, 
    Grid2,
    IconButton,
    Stack,
    Switch,
} from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialBox from "../../../components/MaterialBox";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import MaterialButton from "../../../components/MaterialButton";
import DashboardFooter from "../../../layoutcontainers/DashboardLayout/components/Footer";
import { fetchData, fetchDataById, postData, putData } from "../../../services";
import { useEffect, useReducer, useState } from "react";
import { handelChange } from "../../../reducers/formReducer";
import MaterialSelect from "../../../components/MasterSelect";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";
import DropDownConfig from "../../Utils/DropDownConfig";

const initialState = {
    gInsuranceId: {},
    gInsuranceIdErr: "unchecked",
    mRtoId: {},
    mRtoIdErr: "unchecked",
    code: "",
    codeErr: "unchecked",
    rtoCode: "",
    rtoCodeErr: "unchecked",
    rtoName: "",
    rtoNameErr: "unchecked",
    iRtoRegionId: {},
    iRtoRegionIdErr: "unchecked",
    iRtoZoneId: {},
    iRtoZoneIdErr: "unchecked",
    iCityId: {},
    iCityIdErr: "unchecked",
    isActive: false,
};

const RtoForm = () => {
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();
    const [state, dispatch] = useReducer(handelChange, initialState);
    const [dropdown, setDropdown] = useState({
        insurance: [],
        motorRto: [],
        region: [],
        zone: [],
        city: [],
    });

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const Id = searchParams.get("id");
    const pageType = searchParams.get("pageType");

    const pageMode =
        pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";

    // Fetch Insurance dropdown
    useEffect(() => {
        const fetchInsuranceList = async () => {
            setCircleLoading(true);
            try {
                const response = await fetchData(
                    `/reference/general/insurer-master?dropdown=true&isActive=true`
                );

                setDropdown((prev) => ({
                    ...prev,
                    insurance: response?.data?.items?.map((item) => ({
                        value: item?.id,
                        label: item?.companyName,
                    })),
                }));
            } catch (error) {
                console.error("Error Fetching Insurance List:", error);
            } finally {
                setCircleLoading(false);
            }
        };

        fetchInsuranceList();
    }, []);

    // Fetch City RTO dropdown
    useEffect(() => {
        const fetchCityRtoList = async () => {
            setCircleLoading(true);
            try {
                const response = await fetchData(
                    `/reference/motor/rto?dropdown=true&isActive=true`
                );

                setDropdown((prev) => ({
                    ...prev,
                    motorRto: response?.data?.items?.map((item) => ({
                        value: item?.id,
                        label: item?.displayName,
                    })),
                }));
            } catch (error) {
                console.error("Error Fetching City RTO List:", error);
            } finally {
                setCircleLoading(false);
            }
        };

        fetchCityRtoList();
    }, []);

    // Fetch RTO Region dropdown
    useEffect(() => {
        const fetchRegionList = async () => {
            setCircleLoading(true);
            try {
                const response = await fetchData(
                    `/reference/insurer/key_value_store?code=${DropDownConfig?.insurerRtoRegion}&dropdown=true&isActive=true`
                );

                setDropdown((prev) => ({
                    ...prev,
                    region: response?.data?.items?.map((item) => ({
                        value: item?.id,
                        label: item?.regionName,
                    })),
                }));
            } catch (error) {
                console.error("Error Fetching Region List:", error);
            } finally {
                setCircleLoading(false);
            }
        };

        fetchRegionList();
    }, []);

    // Fetch RTO Zone dropdown
    useEffect(() => {
        const fetchZoneList = async () => {
            setCircleLoading(true);
            try {
                const response = await fetchData(
                    `/reference/insurer/key_value_store?code=${DropDownConfig?.insurerRtoZone}&dropdown=true&isActive=true`
                );

                setDropdown((prev) => ({
                    ...prev,
                    zone: response?.data?.items?.map((item) => ({
                        value: item?.id,
                        label: item?.zoneName,
                    })),
                }));
            } catch (error) {
                console.error("Error Fetching Zone List:", error);
            } finally {
                setCircleLoading(false);
            }
        };

        fetchZoneList();
    }, []);

    // Fetch City dropdown
    useEffect(() => {
        const fetchCityList = async () => {
            setCircleLoading(true);
            try {
                const response = await fetchData(
                    `/reference/insurer/city?dropdown=true&isActive=true`
                );

                setDropdown((prev) => ({
                    ...prev,
                    city: response?.data?.items?.map((item) => ({
                        value: item?.id,
                        label: item?.cityName,
                    })),
                }));
            } catch (error) {
                console.error("Error Fetching City List:", error);
            } finally {
                setCircleLoading(false);
            }
        };

        fetchCityList();
    }, []);

    // Fetch RTO by ID for edit/view mode
    useEffect(() => {
        const fetchRtoById = async () => {
            setCircleLoading(true);
            try {
                const data = await fetchDataById(`/reference/insurer/rto/${Id}`);
                const responseData = data?.data;

                if (data?.success) {
                    dispatch({
                        type: "bulkUpdate",
                        payload: {
                            gInsuranceId: {
                                value: responseData?.gInsurerId,
                                label: responseData?.gInsurerName,
                            },
                            mRtoId: {
                                value: responseData?.mRtoId,
                                label: responseData?.mRtoName,
                            },
                            iRtoRegionId: {
                                value: responseData?.iRtoRegionId,
                                label: responseData?.iRtoRegionName,
                            },
                            iRtoZoneId: {
                                value: responseData?.iRtoZoneId,
                                label: responseData?.iRtoZoneName,
                            },
                            iCityId: {
                                value: responseData?.iCityId,
                                label: responseData?.iCityName,
                            },
                            code: responseData?.code,
                            rtoCode: responseData?.rtoCode,
                            rtoName: responseData?.rtoName,
                            isActive: responseData?.isActive,
                        },
                    });
                }
            } catch (error) {
                console.error("Error fetching data by ID:", error);
            } finally {
                setCircleLoading(false);
            }
        };
        if (Id) {
            fetchRtoById();
        }
    }, [Id]);

    const handelSubmit = async () => {
        const payload = {
            gInsurerId: state?.gInsuranceId?.value,
            mRtoId: state?.mRtoId?.value,
            code: state?.code,
            rtoCode: state?.rtoCode,
            rtoName: state?.rtoName,
            iRtoRegionId: state?.iRtoRegionId?.value,
            iRtoZoneId: state?.iRtoZoneId?.value,
            iCityId: state?.iCityId?.value,
            isActive: state?.isActive,
        };

        if (pageMode === "edit") {
            try {
                setCircleLoading(true);
                const response = await putData(`/reference/insurer/rto/${Id}`, payload);
                const responseMessage = response?.message;
                if (response?.success) {
                    showSnackbar(responseMessage, "success");
                    navigate("/insurer-master/insurer-rto");
                } else {
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                showSnackbar(error?.response?.data?.message, "error");
            } finally {
                setCircleLoading(false);
            }
        } else {
            try {
                setCircleLoading(true);
                const response = await postData("/reference/insurer/rto", payload);
                const responseMessage = response?.message;
                if (response?.success) {
                    showSnackbar(responseMessage, "success");
                    navigate("/insurer-master/insurer-rto");
                } else {
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                showSnackbar(error?.response?.data?.message, "error");
            } finally {
                setCircleLoading(false);
            }
        }
    };

    const checkAllFields = () => {
        let allowSubmit = false;

        if (
            state.gInsuranceIdErr === "success" &&
            state.mRtoIdErr === "success" &&
            state.codeErr === "success" &&
            state.rtoCodeErr === "success" &&
            state.rtoNameErr === "success" &&
            state.iRtoRegionIdErr === "success" &&
            state.iRtoZoneIdErr === "success" &&
            state.iCityIdErr === "success"
        ) {
            allowSubmit = false;
        } else {
            allowSubmit = true;
        }

        return allowSubmit;
    };

    return (
        <>
            <DashboardLayout>
                <Card sx={{ minHeight: 500 }}>
                    <CardHeader
                        title={
                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                spacing={2}
                            >
                                <Stack direction="row" alignItems="center" spacing={1}>
                                    <IconButton
                                        onClick={() =>
                                            navigate("/insurer-master/insurer-rto")
                                        }
                                    >
                                        <ArrowBack />
                                    </IconButton>
                                    <Stack direction="column" spacing={0}>
                                        <MaterialTypography variant="h5" fontWeight="medium">
                                            RTO Details
                                        </MaterialTypography>
                                        <MaterialTypography variant="caption" color="text">
                                            Enter New RTO Details.
                                        </MaterialTypography>
                                    </Stack>
                                </Stack>
                            </Stack>
                        }
                    />

                    <CardContent>
                        <Grid2 container spacing={2}>
                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        General Insurance <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialSelect
                                    name="gInsuranceId"
                                    options={dropdown?.insurance}
                                    value={state?.gInsuranceId}
                                    onChange={(e) =>
                                        dispatch({
                                            type: "Select",
                                            value: e,
                                            name: "gInsuranceId",
                                        })
                                    }
                                    success={state?.gInsuranceIdErr === "success"}
                                    error={state.gInsuranceIdErr === "error"}
                                    isDisabled={pageMode === "view"}
                                />
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Motor RTO <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialSelect
                                    name="mRtoId"
                                    options={dropdown?.motorRto}
                                    value={state?.mRtoId}
                                    onChange={(e) =>
                                        dispatch({
                                            type: "Select",
                                            value: e,
                                            name: "mRtoId",
                                        })
                                    }
                                    success={state?.mRtoIdErr === "success"}
                                    error={state.mRtoIdErr === "error"}
                                    isDisabled={pageMode === "view"}
                                />
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Code <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialInput
                                    name="code"
                                    value={state?.code}
                                    onChange={(e) =>
                                        dispatch({
                                            value: e?.target?.value,
                                            name: "code",
                                            type: "input",
                                            regex: "^([\\s\\S]{1,20})$",
                                        })
                                    }
                                    success={state?.codeErr === "success"}
                                    error={state.codeErr === "error"}
                                    disabled={pageMode === "view"}
                                />
                                {state.codeErr === "error" && (
                                    <FormControl error>
                                        <FormHelperText>
                                            Code should be a minimum 1 character & maximum 20
                                            characters long.
                                        </FormHelperText>
                                    </FormControl>
                                )}
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        RTO Code <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialInput
                                    name="rtoCode"
                                    value={state?.rtoCode}
                                    onChange={(e) =>
                                        dispatch({
                                            value: e?.target?.value,
                                            name: "rtoCode",
                                            type: "input",
                                            regex: "^([\\s\\S]{1,20})$",
                                        })
                                    }
                                    success={state?.rtoCodeErr === "success"}
                                    error={state.rtoCodeErr === "error"}
                                    disabled={pageMode === "view"}
                                />
                                {state.rtoCodeErr === "error" && (
                                    <FormControl error>
                                        <FormHelperText>
                                            RTO Code should be a minimum 1 character & maximum 20
                                            characters long.
                                        </FormHelperText>
                                    </FormControl>
                                )}
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        RTO Name <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialInput
                                    name="rtoName"
                                    value={state?.rtoName}
                                    onChange={(e) =>
                                        dispatch({
                                            value: e?.target?.value,
                                            name: "rtoName",
                                            type: "input",
                                            regex: "^([\\s\\S]{1,60})$",
                                        })
                                    }
                                    success={state?.rtoNameErr === "success"}
                                    error={state.rtoNameErr === "error"}
                                    disabled={pageMode === "view"}
                                />
                                {state.rtoNameErr === "error" && (
                                    <FormControl error>
                                        <FormHelperText>
                                            RTO Name should be a minimum 1 character & maximum 60
                                            characters long.
                                        </FormHelperText>
                                    </FormControl>
                                )}
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        RTO Region <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialSelect
                                    name="iRtoRegionId"
                                    options={dropdown?.region}
                                    value={state?.iRtoRegionId}
                                    onChange={(e) =>
                                        dispatch({
                                            type: "Select",
                                            value: e,
                                            name: "iRtoRegionId",
                                        })
                                    }
                                    success={state?.iRtoRegionIdErr === "success"}
                                    error={state.iRtoRegionIdErr === "error"}
                                    isDisabled={pageMode === "view"}
                                />
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        RTO Zone <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialSelect
                                    name="iRtoZoneId"
                                    options={dropdown?.zone}
                                    value={state?.iRtoZoneId}
                                    onChange={(e) =>
                                        dispatch({
                                            type: "Select",
                                            value: e,
                                            name: "iRtoZoneId",
                                        })
                                    }
                                    success={state?.iRtoZoneIdErr === "success"}
                                    error={state.iRtoZoneIdErr === "error"}
                                    isDisabled={pageMode === "view"}
                                />
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        City <span className="span">*</span>
                                    </MaterialTypography>
                                </MaterialBox>
                                <MaterialSelect
                                    name="iCityId"
                                    options={dropdown?.city}
                                    value={state?.iCityId}
                                    onChange={(e) =>
                                        dispatch({
                                            type: "Select",
                                            value: e,
                                            name: "iCityId",
                                        })
                                    }
                                    success={state?.iCityIdErr === "success"}
                                    error={state.iCityIdErr === "error"}
                                    isDisabled={pageMode === "view"}
                                />
                            </Grid2>

                            <Grid2 size={{ lg: 6, md: 6, sm: 12, xs: 12 }}>
                                <MaterialBox>
                                    <MaterialTypography
                                        component="label"
                                        variant="caption"
                                        fontWeight="bold"
                                    >
                                        Active
                                    </MaterialTypography>
                                </MaterialBox>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={state?.isActive}
                                            onChange={() =>
                                                dispatch({
                                                    type: "switch",
                                                    name: "isActive",
                                                    value: !state?.isActive,
                                                })
                                            }
                                            color="primary"
                                            disabled={pageMode === "view"}
                                        />
                                    }
                                    label={
                                        <MaterialTypography variant="caption" fontWeight="bold">
                                            {state?.isActive ? "Active" : "Inactive"}
                                        </MaterialTypography>
                                    }
                                />
                            </Grid2>
                        </Grid2>
                    </CardContent>

                    <MaterialBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        {pageMode !== "view" && (
                            <>
                                <MaterialButton
                                    sx={{ m: 2 }}
                                    variant="outlined"
                                    color="dark"
                                    onClick={() =>
                                        navigate("/insurer-master/insurer-rto")
                                    }
                                >
                                    Cancel
                                </MaterialButton>
                                <MaterialButton
                                    sx={{ m: 2 }}
                                    variant="gradient"
                                    color="dark"
                                    disabled={checkAllFields()}
                                    onClick={handelSubmit}
                                >
                                    {pageMode === "add" ? "Submit" : "Edit"}
                                </MaterialButton>
                            </>
                        )}
                    </MaterialBox>
                </Card>
            </DashboardLayout>
            <DashboardFooter />
        </>
    );
};

export default RtoForm;
